import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicationComponent } from './medication.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared/shared-components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { TierModalComponent } from './components/tier-modal/tier-modal.component';
import { AlternateMedicationTableComponent } from './components/alternate-medication-table/alternate-medication-table.component';
import { MedicationRoutingModule } from './medication-routing.module';
import { MainModule } from '../main/main.module';

@NgModule({
  declarations: [MedicationComponent, TierModalComponent, AlternateMedicationTableComponent],
  imports: [
    CommonModule,
    MainModule,
    FormsModule,
    MedicationRoutingModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatFormFieldModule, MatInputModule, MatSelectModule, MatAutocompleteModule, MatIconModule
  ],
  exports: [
    MedicationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MedicationModule { }
